const contactItems = [
  {
    icon: 'ri-mail-line',
    label: 'Email Us',
    value: 'info@designassist.net',
    href: 'mailto:info@designassist.net',
    description: 'For general inquiries and project questions',
  },
  {
    icon: 'ri-time-line',
    label: 'Response Time',
    value: 'Within 24 Hours',
    href: null,
    description: 'We respond to every inquiry, every time',
  },
  {
    icon: 'ri-map-pin-line',
    label: 'Based In',
    value: 'United States',
    href: null,
    description: 'Serving design professionals nationwide',
  },
];

export default function ContactDetails() {
  return (
    <section className="py-20 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#C5A572] text-sm font-semibold uppercase tracking-widest mb-3">Get In Touch</p>
          <h3 className="text-4xl font-bold text-[#2B2B2B]">
            Reach us any way that works for <span className="font-serif italic">you</span>
          </h3>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-3 gap-6">
            {contactItems.map((item) => (
              <div key={item.label} className="bg-white rounded-3xl p-8 text-center">
                <div className="w-14 h-14 bg-[#F5F0EB] rounded-2xl flex items-center justify-center mx-auto mb-5 border border-[#C5A572]/20">
                  <i className={`${item.icon} text-[#C5A572] text-2xl`}></i>
                </div>
                <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-2">{item.label}</p>
                {item.href ? (
                  <a
                    href={item.href}
                    className="text-lg font-bold text-[#2B2B2B] hover:text-[#C5A572] transition-colors cursor-pointer block mb-2"
                  >
                    {item.value}
                  </a>
                ) : (
                  <p className="text-lg font-bold text-[#2B2B2B] mb-2">{item.value}</p>
                )}
                <p className="text-gray-500 text-xs leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
